'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const ShiftTextGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ShiftHeader = styled.h1`
  font-size: ${({ theme }) => theme.typography.heading1.fontSize};
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${({ theme }) => theme.typography.heading1.fontWeight};
  line-height: ${({ theme }) => theme.typography.heading1.lineHeight};
  padding-bottom: ${Spacers.LG}rem;
`;

export const ShiftTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.title.fontSize}; 
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${({ theme }) => theme.typography.title.fontWeight}; 
  line-height: ${({ theme }) => theme.typography.title.lineHeight};
  padding-bottom: ${Spacers.XS}rem;
`;

export const ShiftDescription = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
`; 